import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'app/shared/api/microservices';

const baseUrl = `${process.env.CONFIG_MANAGER_URL}${process.env.CONFIG_MANAGER_PORT && process.env.CONFIG_MANAGER_PORT !== '' ? `:${process.env.CONFIG_MANAGER_PORT}` : ''}`;
const staggeredBaseQuery = axiosBaseQuery({ baseUrl });

export const configManagerCloudServicesApi = createApi({
  reducerPath: 'configManagerCloudServicesApi',
  baseQuery: staggeredBaseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'USER_PROFILE',
    'ACCOUNT_PROFILE',
    'ACCOUNT_LIST',
    'BILLING_PROFILE',
    'SUBSCRIPTIONS',
    'MEMBER_LIST',
    'INVITATION_LIST',
    'SUBACCOUNT_LIST',
  ],
});
